<template>
    <div class="honorblock-container">
      <div class="main-box page-content-box">
        <BlockTitle
          title="成就荣誉"
          channelAlias="rongyu"></BlockTitle>

        <Quotation
          class="quotation"
          style="width:80%;"
         :content="quotationContent"></Quotation>
        <div class="block-items">
          <HonorItem
            class="block-item"
            itemType="1"></HonorItem>
          <HonorItem
            class="block-item"
            itemType="2"></HonorItem>
          <HonorItem
            class="block-item"
            itemType="3"></HonorItem>
        </div>
        <swiper class="honor-swiper" ref="swiper" :options="swiperOption">
          <swiper-slide
            
            class="honor-slide"
            v-for="(item, index) in honorImageList"
            :key="index">    
                <img :src="item.image"/>
                <a href="/rongyu?tab=rongyujiangli" class="title" data-aos="fade-up" data-aos-duration="350"><div style="padding: 10px;">{{item.title}}</div></a>        
          </swiper-slide>            
        </swiper>
      </div>
    </div>
</template>
<script>
  import BlockTitle from "@/components/blocks/blocktitle";
  import Quotation from "@/components/blocks/quotation";
  import HonorItem from "./honoritem.vue";
  import "swiper/dist/css/swiper.css";
  import { swiper, swiperSlide } from 'vue-awesome-swiper';

    export default{
      components: {BlockTitle, Quotation, HonorItem, swiper, swiperSlide},
        props:{

        },
        data(){
            return {
              quotationContent: "我从小学五年级开始做学生干部，直到大学毕业。十二年的学生干部经历使我懂得要以身作则，为别人着想；要诚恳待人， 虚心接受各方面的批评。这些是一个人能够做出成绩的不可缺少的素质，尤其是学术带头人必须具备的素质。",
              honorImageList: [
                {
                  title:'1986年，获日内瓦国际发明展览金奖',
                  image: require('@/assets/img/honor01.jpg'),
                },
                {
                  title:'1987年获国家科学进步一等奖',
                  image: require('@/assets/img/honor02.jpg'),
                },
                {
                  title:'1987年获首届毕昇奖',
                  image: require('@/assets/img/honor03.jpg'),
                },
                {
                  title:'1989年，获中国专利发明创造金奖',
                  image: require('@/assets/img/honor04.jpg'),
                },
                {
                  title:'1995年，获联合国教科文组织科学奖',
                  image: require('@/assets/img/honor05.jpg'),
                },
                {
                  title:'1995年获国家科技进步一等奖',
                  image: require('@/assets/img/honor06.jpg'),
                },
                {
                  title:'2002年，获国家最高科学技术奖',
                  image: require('@/assets/img/honor07.jpg'),
                },
                {
                  title:'2009年，被评选为新中国成立以来感动中国人物',
                  image: require('@/assets/img/honor08.jpg'),
                },
                {
                  title:'2009年被评为新中国成立六十年最具影响的劳动模范',
                  image: require('@/assets/img/honor09.jpg'),
                },
                {
                  title:'2018年，被授予“改革先锋”称号',
                  image: require('@/assets/img/honor10.jpg'),
                },
                {
                  title:'2019年，被授予“最美奋斗者”称号',
                  image: require('@/assets/img/honor11.jpg'),
                },
              ],
              swiperOption: {
                slidesPerView: 'auto',
                spaceBetween: 0,
                direction: 'horizontal',
                freeMode: true,                    
                centerInsufficientSlides: true,            
              },
            };
        },
        methods:{},
        created(){},
        mounted(){},
    };
</script>
<style scoped>
  .honorblock-container{
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    background: rgba(216, 220, 226, 0.4);
    background-image: url('../../../assets/img/home-bg-rongyu.png');
    background-repeat: no-repeat;
    background-position:top right;
    background-size: 600px;
 }

 .main-box{
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: center;
    /*gap: 40px;*/
    padding: 60px 0px;
 }
 .quotation{
  margin-top: 40px;
 }

 .block-items{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;
  /*gap: 40px;*/
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;  
  margin-top: 40px;
  margin-left: -20px;
  margin-right: -20px;
 }
 .block-item{
  margin-left: 20px;
  margin-right: 20px;
 }

 .honor-swiper{
  width: 100%;
  background-color: #fff;
  padding: 16px 0px;
  margin-top: 40px;
 }
 .honor-slide{
  width: auto;
  height: 220px;
  margin: 0 10px !important;
  box-sizing: border-box !important;
 }

 .honor-slide img{
  width: auto;
  height: 100%;
  object-fit: cover;
  
 }
 .honor-slide .title{
    position: absolute;
    background-color: #000;
    color: #fff !important;
    left: 0 !important;
    bottom: 0 !important;
    opacity: 0.6 !important;
    width: 100%;
    height: 0px !important;     
    font-size: 14px;
    box-sizing: border-box;
    transition: all 0.35s ease-in-out;
    box-sizing: border-box;
 }

 .honor-slide:hover .title{  
  color: #fff !important;
  height: 60px !important;
  width: 100%;  
  opacity: 0.6 !important;
 }


 .el-row{
  width: 100%;
 }

 .el-col{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
 }

 .honor-image-list{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0px;
  width: 100%;
  gap: 30px;
 }
 .honor-image-item{
  width: 200px;
  height: 240px;
  overflow: hidden;
 }
 .honor-image-item img{
  width: 100%;
  height: 100%;
  transition:all 0.35s ease-in-out;
  overflow: hidden;
 }
.honor-image-item img:hover{
  opacity:0.7;
  transform: scale(1.1);
  overflow: hidden;
}
@media screen and (max-width: 1000px) {  
  .main-box{
    /*gap: 20px;*/
    padding: 24px 10px;
  }
  .quotation{
    margin-top: 20px;
  }

  .block-items{
    margin-top: 20px;
  }

  .honor-swiper{
    margin-top: 20px;
  }
}  
@media screen and (max-width: 750px){
  /*
  .main-box{
    gap: 12px;    
  }
  */
  .quotation{
    margin-top: 12px;
  }
  .block-items{
    /*gap: 4px;*/
    margin-top: 12px;
    margin-left: -2px;
    margin-right: -2px;
  }
  .block-item{
    margin-left: 2px;
    margin-right: 2px;
  }
  .honor-swiper{
    margin-top: 12px;
  }
  .honor-slide{
    width: auto;
    height: 140px;
    margin: 0px 5px;
  }

}
</style>



// WEBPACK FOOTER //
// src/components/blocks/honorblock/index.vue